export var CreateTeamErrorCodes;
(function (CreateTeamErrorCodes) {
    CreateTeamErrorCodes["DUPLICATE_ENTITY"] = "DUPLICATE_ENTITY";
})(CreateTeamErrorCodes || (CreateTeamErrorCodes = {}));
